import React, { Component } from 'react';
import classnames from 'classnames';
import { string, node, object, func } from 'prop-types';

import Swiper from 'swiper/dist/js/swiper.js';

import './Carousel.global.css';

class Carousel extends Component {
  static propTypes = {
    className: string,
    children: node,
    onMount: func,
    onDismount: func,
    options: object
  }

  swiper = null;

  componentDidMount = () => {
    const { options, onMount } = this.props;

    this.swiper = new Swiper('.swiper-container', {...options});

    onMount && onMount(this.swiper);
  }

  componentWillUnmount = () => {
    const { onDismount } = this.props;

    onDismount && onDismount(this.swiper);
  }

  render () {
    const { children, className } = this.props;

    return (
      <div className={classnames('swiper-container', className)}>
        <ul className="swiper-wrapper">
          {children}
        </ul>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/uis/common/Carousel/Carousel.js